<ul>
  @for (item of items; track trackById($index, item)) {
    <li [class.moved]="isCollapsed">
      @if (item.name !== 'Employee') {
        <a class="flex-container child" (click)="selectCategory(item)" [ngClass]="{'active': item.id == coIdFromUrl}">
          @if (item.icon) {
            <mat-icon matPrefix>
              <i [class]="item.icon"></i>
            </mat-icon>
          }
          @if (isCollapsed) {
            <span [ngClass]="{'selected-category': selectedCategory === item}">{{ item.name }}</span>
          }
        </a>
      }
    </li>
  }
</ul>



